import { render, staticRenderFns } from "./InfoVarejo.vue?vue&type=template&id=b8c8db8c&scoped=true&"
import script from "./InfoVarejo.vue?vue&type=script&lang=js&"
export * from "./InfoVarejo.vue?vue&type=script&lang=js&"
import style0 from "./InfoVarejo.vue?vue&type=style&index=0&id=b8c8db8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c8db8c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
